import { render, staticRenderFns } from "./SignaturePage.vue?vue&type=template&id=7b39cb44&scoped=true&"
import script from "./SignaturePage.vue?vue&type=script&lang=ts&"
export * from "./SignaturePage.vue?vue&type=script&lang=ts&"
import style0 from "./SignaturePage.vue?vue&type=style&index=0&id=7b39cb44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b39cb44",
  null
  
)

export default component.exports